import { styled } from '@mui/material/styles';
import Box from '@mui/material/Box';

const ContentWrapper = styled(Box)(() => ({
    backgroundColor: 'white',
}));

export default ContentWrapper;
